import {
  BPTrinkgeldRequest,
  Bezahlart,
  TrinkgeldType,
  RemoteResult,
  BPAufgebenRequest,
  Bestellung,
  BestellungPending,
} from "mangdto"
import BaseLogic from "../base_logic"
import Formatter from "../formatter"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import router from "@/router"
import RouteNames from "@/util/route_names"

export default class TrinkgeldLogic extends BaseLogic {
  gesamtpreis: number
  prozent5: number
  prozent10: number
  andererBetrag: number

  type: TrinkgeldType = TrinkgeldType.Percent10

  init() {
    var warenkorb = this.mainLogic.bestellungPending.artikelliste
    this.gesamtpreis = Formatter.berechnePreisListe(warenkorb)

    this.prozent5 = this.gesamtpreis * 0.05
    this.prozent10 = this.gesamtpreis * 0.1
  }

  weiter() {
    var betrag: number = 0

    var request = new BPTrinkgeldRequest()
    request.type = this.type

    if (this.type == TrinkgeldType.Percent5) {
      betrag = this.gesamtpreis * 0.05
    } else if (this.type == TrinkgeldType.Percent10) {
      betrag = this.gesamtpreis * 0.1
    } else if (this.type == TrinkgeldType.Custom) {
      betrag = this.andererBetrag
    }

    request.trinkgeld = betrag

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingTrinkgeldFestlegen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending.trinkgeldType = this.type
        this.mainLogic.bestellungPending.trinkgeld = betrag

        this.bestellungAufgeben()
      }
    })
  }

  bestellungAufgeben() {
    var request = new BPAufgebenRequest()
    request.bezahlart = Bezahlart.Paypal

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungpendingAufgeben,
      request,
    ).then((response) => {
      if (response.data.success) {
        var dto = response.data.payload

        this.mainLogic.bestellung = dto
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.neueBestellung = false

        router.push({
          name: RouteNames.NEU.BEZAHLUNG_WEITERLEITEN,
          params: { bestellungId: dto.id },
        })
      }
    })
  }
}
